<template>
  <div>
    <label v-text="label" :for="id" :class="{'tw-text-red': hasError}"></label>
    <small v-if="hasError" v-text="this.error" class="tw-text-red"></small>
    <textarea
      class="form-control"
      :class="inputClass"
      :id="id"
      :required="required"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      @keyup.enter="onEnter"
      @input="updateInput($event.target.value)"
      :rows="rows"
      :maxlength="maxLength"
    ></textarea>
  </div>
</template>

<script>
  import inputMixin from './input';

  export default {
    name: 'BlastTextArea',

    props: [
      'rows',
      'maxLength',
    ],

    mixins: [
      inputMixin,
    ],
  };
</script>
